"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseSvg = void 0;
var _react = _interopRequireDefault(require("react"));
var _excluded = ["viewBoxSize", "size", "width", "height", "children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
/**
 * Wrapper component for <svg> icon elements
 *
 * NOTE: The viewBoxSize should always be either 8, 16 or 24, 32 according to the parent frame size
 * in the master design system, not the size of the actual vector graph, resulting in
 * an icon that has some "internal padding".
 * Ex. an icon in a 16x16 parent frame may have an "internal size" of 12x10, 14x14, etc.
 * The internal padding makes it easier to align icons with other sibling elements such as
 * text labels in buttons, so icons that are more likely to be used that way
 * will have internal padding.
 * When looking at designs in Figma, be sure to calculate spacing based on
 * the parent frame of the icon.
 */

var BaseSvg = function BaseSvg(_ref) {
  var viewBoxSize = _ref.viewBoxSize,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? viewBoxSize : _ref$size,
    width = _ref.width,
    height = _ref.height,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 ".concat(viewBoxSize, " ").concat(viewBoxSize),
    width: "".concat(width || size, "px"),
    height: "".concat(height || size, "px"),
    xmlns: "http://www.w3.org/2000/svg"
  }, props), children);
};
exports.BaseSvg = BaseSvg;